module.exports = "/static/assets/3947903ddb159c7e7cd203eb79bda07f.png";